// @ts-nocheck
import { BoxV2 } from 'sonata-react-components';
import styled from 'styled-components';

type Props = {
  header: 'single' | 'multi';
  marginRight?: string;
};

export const BoxStyled = styled(BoxV2)<Props>`
  height: 32px;
  margin-right: ${props => (props.marginRight ? `${props.marginRight}px` : '')};
  ${props => (props.header === 'multi' ? 'width: 50%' : 'max-width: 282px')};
  .header {
    &__descriptionBoxDetailsBody {
      background-color: ${props => props.theme.uiColors.boxBgMultiHeader};
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
    }
  }
`;
